import type { PeerGetIdAnswerPayload } from '@playcastdotio/Messaging';

/**
 * ICE credentials exactly as signaling delivers them. Cloudflare mints one
 * username/credential pair that covers every URL in `urls`, so both the
 * `PEER_GET_ID_ANSWER` payload and `GET /realtime/ice-servers` carry a single
 * object rather than a list.
 */
export type SignalingIceCredentials = NonNullable<PeerGetIdAnswerPayload['iceServers']>;

/**
 * Wrap the single wire bundle into the list `RTCConfiguration.iceServers`
 * wants. Passing the bare object straight into an `RTCIceServer[]` slot leaves
 * consumers reading `.length` as `undefined`, which silently drops the
 * refreshed TURN credentials instead of applying them.
 */
export function toRtcIceServers(
  credentials: SignalingIceCredentials | null | undefined,
): RTCIceServer[] | undefined {
  return credentials ? [credentials] : undefined;
}
